(function(){
    angular
        .module('appback')
        .directive('ngCultivobilateral', cultivobilateral);

        cultivobilateral.$inject = ['ResultadosService','MicroService','$timeout'];
        function cultivobilateral(ResultadosService,MicroService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=cultivobilateral.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
			            if(!scope.item.resultado){
			            	scope.item.resultado = { extra : { resultado : { antibiogramas:[], microorganismos : [{}], medioscondiciones:[],bioquimicas : [{ }], historico:[{}] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { antibiogramas:[], microorganismos : [], medioscondiciones:[], bioquimicas : [{ }], historico:[{}] }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { };
					            	}
					            }
					            
				            	if(!scope.item.resultado.extra.resultado.microorganismos){
				            		scope.item.resultado.extra.resultado.microorganismos = [];
				            	}

				            	if(!scope.item.resultado.extra.resultado.antibiogramas){
				            		scope.item.resultado.extra.resultado.antibiogramas = [];
				            	}

				            	if(!scope.item.resultado.extra.resultado.bioquimicas){
				            		scope.item.resultado.extra.resultado.bioquimicas = [{}];
				            	}

				            	if(!scope.item.resultado.extra.resultado.historico){
				            		scope.item.resultado.extra.resultado.historico = [{}];
				            	}
				            	/*if(!scope.item.resultado.extra.resultado.medioscondiciones){
				            		ResultadosService.getMediosCondiciones(scope.item.analitica_id,function(data){
				            			if(data.medioscondiciones.length>0){
				            				scope.item.resultado.extra.resultado.medioscondiciones = [];
				            				for(var cont=0;cont<data.medioscondiciones.length;cont++){
					            				scope.item.resultado.extra.resultado.medioscondiciones.push({medio:data.medioscondiciones[cont].medios_id,condicion:data.medioscondiciones[cont].condiciones_id});
					            			}
				            			}else{
					            			scope.item.resultado.extra.resultado.medioscondiciones = [];
				            			}
						            });
				            	}*/
				            }
				        }

				        /*scope.revisarHecho = function(){
				        	var res = false;
				        	if(scope.item.resultado.extra){
				        		if(scope.item.resultado.extra.resultado){
				        			console.log(scope.item.resultado.extra);
				        		}
				        	}
				        }
				        scope.revisarHecho();
						*/

						/*ESTO LO PIDIERON PROVISIONAL*/
				        //scope.pendientevalidarRes = 1;
				        scope.getPendienteValidar = function(){
				        	console.log("GETPEND");
							MicroService.getPendienteValidar(scope.item.peticion_id,scope.item.analitica_id,function(data){
		            			scope.pendientevalidarRes = data.pendientevalidar;
				            });
				        }
				        scope.getPendienteValidar();

						scope.pendienteValidar = function(){
							console.log("PENDIENTE");
							MicroService.marcarValidar(scope.pendientevalidarRes,scope.item.peticion_id,scope.item.analitica_id,function(data){
		            			
				            });
						}
				        /*
						----------------------------------------------------
				        ESTO LO PIDIERON PROVISIONAL*/

				        scope.loadMedios = function(){
		            		ResultadosService.getMediosCondiciones(scope.item.analitica_id,scope.centro.pais_id,function(data){
		            			if(data.medioscondiciones.length>0){
		            				scope.item.resultado.extra.resultado.medioscondiciones = [];
		            				for(var cont=0;cont<data.medioscondiciones.length;cont++){
			            				scope.item.resultado.extra.resultado.medioscondiciones.push({medio:data.medioscondiciones[cont].medios_id,condicion:data.medioscondiciones[cont].condiciones_id});
			            			}
		            			}else{
			            			scope.item.resultado.extra.resultado.medioscondiciones.push({});
		            			}
				            });
		            	}

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                    }

	                    scope.revisarAnti = function(micro,index){
	                    	if(typeof(scope.item.resultado.extra.resultado.antibiogramas[index])=='undefined'){
	                    		scope.item.resultado.extra.resultado.antibiogramas.push({});
	                    	}
	                    	scope.item.resultado.extra.resultado.antibiogramas[index].loadingField = true;
	                    	scope.item.resultado.extra.resultado.antibiogramas[index].microorganismo = micro.microorganismo;
	                    	$timeout(function(){
	                    		scope.item.resultado.extra.resultado.antibiogramas[index].loadingField = false;
	                    	},100);
	                    	
	                    }

						scope.getAntibiogramaAislado = function(micro){
							console.log("Searching antibiograma", micro.microorganismo, scope.item.peticion_id, scope.item.analitica_id);
							MicroService.getAntibiogramaAislado(micro.microorganismo, scope.item.peticion_id, scope.item.analitica_id, function(data){
								console.log("Antibiograma aislado", data);
								micro.antibiograma_names = data.antibiograma_names;
							});
						}


	                    scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	scope.optionsSelect2 = { 
		            		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            //nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

	                	scope.optionsMicroorganismos = { 
		            		ajax: {
		                        url: "/backend/resultadopeticion/select2microorganismo",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

	                	scope.borrarMedioCond =function(index){
	                		scope.item.resultado.extra.resultado.medioscondiciones.splice(index,1);
	                	}
	                	scope.borrarMicro =function(index){
	                		scope.item.resultado.extra.resultado.microorganismos.splice(index,1);
	                		scope.item.resultado.extra.resultado.antibiogramas.splice(index,1);
	                	}
	                	scope.borrarBQ =function(index){
	                		scope.item.resultado.extra.resultado.bioquimicas.splice(index,1);
	                	}
	                	scope.borrarHist =function(index){
	                		scope.item.resultado.extra.resultado.historico.splice(index,1);
	                	}

	                	scope.nuevoMedio = function(){
	                		scope.item.resultado.extra.resultado.medioscondiciones.push({});
	                	}
	                	scope.nuevoAislamiento = function(){
	                		scope.item.resultado.extra.resultado.microorganismos.push({});
	                		scope.item.resultado.extra.resultado.antibiogramas.push({});
	                	}

	                	scope.nuevaBio = function(){
	                		scope.item.resultado.extra.resultado.bioquimicas.push({});
	                	}
	                	scope.nuevoHist = function(){
	                		scope.item.resultado.extra.resultado.historico.push({});
	                	}


			        });
		        }
          }
      }
})();